import api from '../service/service'
import Swal from 'sweetalert2'
import Chart from 'chart.js'

export default {
  name: 'expennditure_analyze',
  data () {
    return {
      People_count: 0,
      Family_count: 0,
      year: new Date().getFullYear(),
      myChartexpenditure: '',
      listreport: [],
      yearlist: [],
      sumincome: 0,
      sumbalnce: 0,
      trendline: {
        year: new Date().getFullYear(),
        yeartemp: new Date().getFullYear(),
        month: this.getTwoDigitDateFormat(new Date().getMonth() + 1),
        monthtemp: this.getTwoDigitDateFormat(new Date().getMonth() + 1),
        yearbefore: this.getyearbefore(),
        yearbeforetemp: this.getyearbefore(),
        monthbefore: this.getMonthbefore(new Date().getMonth() + 1),
        monthbeforetemp: this.getMonthbefore(new Date().getMonth() + 1)
      }
    }
  },
  methods: {
    changemonthbefore (e) {
      this.getReport('mb')
    },
    changeyear (e) {
      this.getReport('y')
    },
    changeyearbefore (e) {
      this.getReport('yb')
    },
    handleChange (e) {
      this.getReport('m')
    },
    get () {
      var d = new Date(this.trendline.year, parseInt(this.trendline.month), 0).getDate()
      var end = this.trendline.year + '-' + this.trendline.month + '-' + d
      console.log(end)
    },
    getyearbefore () {
      if (this.getTwoDigitDateFormat(new Date().getMonth() + 1) === '01') {
        return new Date().getFullYear() - 1
      } else {
        return new Date().getFullYear()
      }
    },
    getMonthbefore (val) {
      if (this.getTwoDigitDateFormat(val) === '01') {
        return '11'
      } else if (this.getTwoDigitDateFormat(val) === '02') {
        return '12'
      } else {
        val -= 2
        return val < 10 ? '0' + val : '' + val
      }
    },
    getTwoDigitDateFormat (monthOrDate) {
      return monthOrDate < 10 ? '0' + monthOrDate : '' + monthOrDate
    },
    getfullyear () {
      return new Date().getFullYear()
    },
    getyear () {
      var d = new Date()
      for (let i = d.getFullYear(); i >= d.getFullYear() - 50; i--) {
        this.yearlist.push(i)
      }
      console.log(this.yearlist)
    },
    getFamily () {
      api.getFamilyCount(
        result => {
          if (result.result === true) {
            this.Family_count = result.data
          } else {
            Swal.fire('API Family Count Fail!', result.data, 'warning')
          }
        },
        error => {
          Swal.fire('API Family Count Fail!', JSON.stringify(error), 'error')
        }
      )
    },
    getPeople () {
      api.getMemberCount(
        result => {
          if (result.result === true) {
            this.People_count = result.data
          } else {
            Swal.fire('API People Count Fail!', result.data, 'warning')
          }
        },
        error => {
          Swal.fire('API People Count Fail!', JSON.stringify(error), 'error')
        }
      )
    },
    savepdf () {
      const monthNames = ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน',
        'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'
      ]
      let payload = {
        from: 'expenditure',
        from_name: 'รายจ่าย',
        start: monthNames[parseInt(this.trendline.monthbefore)] + ' ' + this.trendline.yearbefore,
        end: monthNames[parseInt(this.trendline.month)] + ' ' + this.trendline.year,
        sumbalnce: this.sumbalnce,
        sumincome: this.sumincome,
        list: this.listreport
      }
      console.log(payload)
      console.log(document.getElementsByName('datasale')[0].value = JSON.stringify(
        payload
      ))
      document.getElementsByName('datasale')[0].value = JSON.stringify(
        payload
      )
    },
    saveExcelXLSX (val) {
      const monthNames = ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน',
        'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'
      ]
      let payload = {
        type: val,
        from: 'income',
        from_name: 'รายรับ',
        start: monthNames[parseInt(this.trendline.monthbefore)] + ' ' + this.trendline.yearbefore,
        end: monthNames[parseInt(this.trendline.month)] + ' ' + this.trendline.year,
        sumbalnce: this.sumbalnce,
        sumincome: this.sumincome,
        list: this.listreport
      }
      console.log(payload) 
      document.getElementsByName('datasaleXLSX')[0].value = JSON.stringify(
        payload
      )
      // document.getElementsByName('datasalexlsx')[1].value = JSON.stringify(
      //   payload
      // )
    },
    saveExcelCSV (val) {
      const monthNames = ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน',
        'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'
      ]
      let payload = {
        type: val,
        from: 'income',
        from_name: 'รายรับ',
        start: monthNames[parseInt(this.trendline.monthbefore)] + ' ' + this.trendline.yearbefore,
        end: monthNames[parseInt(this.trendline.month)] + ' ' + this.trendline.year,
        sumbalnce: this.sumbalnce,
        sumincome: this.sumincome,
        list: this.listreport
      }
      document.getElementsByName('datasaleCSV')[0].value = JSON.stringify(
        payload
      )
      // document.getElementsByName('datasalexlsx')[1].value = JSON.stringify(
      //   payload
      // )
    },
    saveExcelXLS (val) {
      const monthNames = ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน',
        'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'
      ]
      let payload = {
        type: val,
        from: 'income',
        from_name: 'รายรับ',
        start: monthNames[parseInt(this.trendline.monthbefore)] + ' ' + this.trendline.yearbefore,
        end: monthNames[parseInt(this.trendline.month)] + ' ' + this.trendline.year,
        sumbalnce: this.sumbalnce,
        sumincome: this.sumincome,
        list: this.listreport
      }
      document.getElementsByName('datasaleXLS')[0].value = JSON.stringify(
        payload
      )
      // document.getElementsByName('datasalexlsx')[1].value = JSON.stringify(
      //   payload
      // )
    },
    changetemp (val) {
      console.log(val)
      switch (val) {
        case 'y':
          this.trendline.yeartemp = this.trendline.year
          break
        case 'm':
          this.trendline.monthtemp = this.trendline.month
          break
        case 'yb':
          this.trendline.yearbeforetemp = this.trendline.yearbefore
          break
        default:
          this.trendline.monthbeforetemp = this.trendline.monthbefore
      }
    },
    changeback (val) {
      switch (val) {
        case 'y':
          this.trendline.year = this.trendline.yeartemp
          break
        case 'm':
          this.trendline.month = this.trendline.monthtemp
          break
        case 'yb':
          this.trendline.yearbefore = this.trendline.yearbeforetemp
          break
        default:
          this.trendline.monthbefore = this.trendline.monthbeforetemp
      }
    },
    getReport (val) {
      var start = this.trendline.yearbefore + '-' + this.trendline.monthbefore + '-01'
      var d = new Date(this.trendline.year, parseInt(this.trendline.month), 0).getDate()
      const monthNames = ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน',
        'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'
      ]
      var end = this.trendline.year + '-' + this.trendline.month + '-' + d
      let payload = {
        'minDate': start,
        'maxDate': end
      }
      api.getreport(
        payload,
        results => {
          if (results.result === true) {
            this.sumbalnce = 0
            this.sumincome = 0
            console.log(results.data)
            for (var i in results.data) {
              this.sumbalnce += parseInt(results.data[i].balance)
              this.sumincome += parseInt(results.data[i].expenditure)
              // results.data[i].date = results.data[i].create_date.split(' ')[0].split('-')[0] + '-' + results.data[i].create_date.split(' ')[0].split('-')[1]
              results.data[i].monY = monthNames[parseInt(results.data[i].month) - 1] + ' ' + results.data[i].year
            }
            // var res = []
            // var rest = []
            // for (var prop of results.data) {
            //   console.log(prop)
            //   !res.some(value => value && value['date'] === prop['date'])
            //     ? res.push(prop)
            //     : res.forEach(value => {
            //       value['income'] = parseInt(value['income'])
            //       value['balance'] = parseInt(value['balance'])
            //       if (value['date'] === prop['date']) {
            //         value['income'] += parseInt(prop['income'])
            //         value['balance'] += parseInt(value['balance'])
            //       }
            //     })
            // }
            // for (let i in res) {
            //   this.sumbalnce += parseInt(res[i].balance)
            //   this.sumincome += parseInt(res[i].income)
            //   rest.push(res[i])
            // }
            this.income(this.listarrayincome(results.data), this.listarraybalance(results.data), this.listarraymonth(results.data))
            this.listreport = results.data
            console.log(this.sumbalnce)
            this.changetemp(val)
            // eslint-disable-next-line one-var
            // console.log(results)
            // var month = []
            // var income = []
            // var expenditure = []
            // var debt = []
            // var tincome = []
            // var texpenditure = []
            // var tdebt = []
            // result.data.forEach(val => {
            //   month.push(this.monthFormat(val['month']))
            //   income.push(val['income'])
            //   expenditure.push(val['expenditure'])
            //   debt.push(val['debt'])
            // })
            // console.log(income)
            // api.gettrends(
            //   payload,
            //   results => {
            //     results.data.forEach(vals => {
            //       tincome.push(vals['income'])
            //       texpenditure.push(vals['expenditure'])
            //       tdebt.push(vals['debt'])
            //     })
            //     this.sum(results.data)

            //     this.income(this.finnull(this.findmonth(results.data)), this.finnull(this.sum2(results.data)), this.finnull(this.sum(results.data)))
            //     this.getFamily()
            //     this.getPeople()
            //   }
            // )
          } else {
            this.changeback(val)
            Swal.fire('API People Count Fail!', results.data, 'warning')
          }
        },
        error => {
          this.changeback(val)
          Swal.fire('API Report Fail!', JSON.stringify(error), 'error')
        }
      )
    },
    // finnull (array) {
    //   var list = []
    //   for (var i in array) {
    //     if (array[i] != null) {
    //       list.push(array[i])
    //     }
    //   }
    //   return list
    // },
    // sum (array) {
    //   var list = []
    //   for (var i = 1; i <= 12; i++) {
    //     console.log(i)
    //     list[i - 1] = null
    //     for (var j in array) {
    //       if (this.getTwoDigitDateFormat(i) === array[j].create_date.split(' ')[0].split('-')[1]) {
    //         list[i - 1] += parseInt(array[j].balance)
    //       }
    //     }
    //   }
    //   console.log(list)
    //   return list
    // },
    // findmonth (array) {
    //   var list = []
    //   for (var i = 1; i <= 12; i++) {
    //     list[i - 1] = null
    //     console.log(i)
    //     for (var j in array) {
    //       if (this.getTwoDigitDateFormat(i) === array[j].create_date.split(' ')[0].split('-')[1]) {
    //         list[i - 1] = this.getTwoDigitDateFormat(i)
    //       }
    //     }
    //   }
    //   console.log(list)
    //   return list
    // },
    // sum2 (array) {
    //   var list = []
    //   for (var i = 1; i <= 12; i++) {
    //     list[i - 1] = null
    //     console.log(i)
    //     for (var j in array) {
    //       if (this.getTwoDigitDateFormat(i) === array[j].create_date.split(' ')[0].split('-')[1]) {
    //         list[i - 1] += parseInt(array[j].income)
    //       }
    //     }
    //   }
    //   return list
    // },
    listarraybalance (array) {
      var list = []
      for (var i in array) {
        list.push(array[i].balance)
      }
      return list
    },
    listarrayincome (array) {
      var list = []
      for (var i in array) {
        list.push(array[i].expenditure)
      }
      return list
    },
    listarraymonth (array) {
      var list = []
      for (var i in array) {
        list.push(array[i].monY)
      }
      return list
    },
    income ($income, $balance, month) {
      var ctx = document.getElementById('myChartexpenditure').getContext('2d')
      this.myChartexpenditure = new Chart(ctx, {
        type: 'line',
        data: {
          labels: month,
          datasets: [
            {
              label: 'ยอดรายจ่ายของแต่ละเดือน ประจำปี ' + this.year,
              data: $income,
              backgroundColor: '#fff0',
              borderColor: 'blue',
              borderWidth: 3,
              fill: false,
              spanGaps: true,
              tension: 0.5
            },
            {
              label: 'ยอดคงเหลือของแต่ละเดือน',
              data: $balance,
              borderWidth: 3,
              backgroundColor: '#fff0',
              borderColor: 'red',
              // Changes this dataset to become a line
              type: 'line'
            }
          ]
        },
        options: {
          scales: {
            yAxes: [
              {
                ticks: {
                  beginAtZero: false
                }
              }
            ]
          }
        }
      })
    }
  },
  mounted () {
    this.getyear()
    this.getReport()
  }
}



// WEBPACK FOOTER //
// ./src/js/expenditure_analyze.js